/* Shreya — footer: headed columns become accordions on small screens */
(() => {
  if (customElements.get('footer-columns')) return;

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  class FooterColumns extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-accordions')) return;
      this.details = Array.from(this.querySelectorAll('details[data-footer-acc]'));
      if (!this.details.length) return;

      // On desktop the columns are always expanded, so summaries must not toggle
      this.details.forEach((d) => {
        d.querySelector('summary').addEventListener('click', (e) => {
          if (!mobileQuery.matches) e.preventDefault();
        });
      });

      this.onChange = () => this.sync();
      mobileQuery.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      if (this.onChange) mobileQuery.removeEventListener('change', this.onChange);
    }

    sync() {
      const mobile = mobileQuery.matches;
      this.details.forEach((d) => {
        d.open = !mobile;
        const summary = d.querySelector('summary');
        if (mobile) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex', '-1');
      });
    }
  }

  customElements.define('footer-columns', FooterColumns);
})();
